import { formatInTimeZone } from 'date-fns-tz'

const toUtcStartOfDay = (date: Date) =>
  new Date(formatInTimeZone(date, 'UTC', "yyyy-MM-dd'T00:00:00.000Z"))

export const getListingFunnelMaxEndDate = (endsAt: string) => {
  /*
  For performance/UX we want to cap the end date instead of querying all data in existence.

  If shift has already past, the end date is end of shift.
  Otherwise, the end date is current date.
  */
  const shiftEnd = new Date(endsAt)
  const now = new Date()
  const cappedEnd = shiftEnd.getTime() < now.getTime() ? shiftEnd : now

  return toUtcStartOfDay(cappedEnd)
}

export const getDefaultListingFunnelDateRange = (
  createdAt: string,
  endsAt: string
): { from: Date; to: Date } => {
  const created = new Date(createdAt)

  return {
    from: toUtcStartOfDay(created),
    to: getListingFunnelMaxEndDate(endsAt),
  }
}
